export interface ScannerDocumentConfigProps {
  shouldEnforceMrz: boolean;
  mode: ScanDocumentSidesMode;
}

export enum ScanDocumentSidesMode {
  MultiSide = "multi-side",
  OnlyDataPage = "data-page",
  OnlyCardFront = "card-front",
  OnlyCardBack = "card-back",
  CardFrontOrDataPage = "card-front-or-data-page",
  CardBackOrDataPage = "card-back-or-data-page",
}

export class ScannerDocumentConfig {
  shouldEnforceMrz: boolean;
  mode: ScanDocumentSidesMode;

  constructor(props: ScannerDocumentConfigProps) {
    this.shouldEnforceMrz = props.shouldEnforceMrz;
    this.mode = props.mode;
  }
}

export default ScannerDocumentConfig;
